// extracted by mini-css-extract-plugin
export const navigation = "navigation-module--navigation--359yH";
export const action = "navigation-module--action--AOw4K";